<template>
    <div class="report-result year-report-result">
        <!-- 0、全部解锁按钮 -->
        <div id="allButtonBox" v-if="curYearReportData.f_pay == 0" class="year-report-result-btn-box">
            <year-report-button
                v-bind:buttonType="'1'"
                v-bind:buttonText="'138元解锁本页完整报告'"
                v-bind:totalBtn="true"
                v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                v-bind:reportData="reportYearProduct"
                v-bind:clickFunc="clickPay">
            </year-report-button>
            <p class="year-report-result-button-note">原价<del>{{reportYearProduct.rate_price}}</del>元 已有{{reportYearProduct.sold}}人购买</p>
        </div>
        
        <!-- 1、年运综述 -->
        <div id="fiveBox" class="year-content-box" :class="{'year-content-box2': curYearReportData.f_pay != 0}">
            <div class="year-content-light"></div>
            <div class="year-content-light2"></div>
            <div class="year-content-light3"></div>
            <div class="year-content-box-border">
                <div class="year-content-content">
                    <div class="year-content-title year-content-title2"><span>{{curYear}}年年运综述</span></div>
                    <div class="year-content-content-c no-bg">
                        <div v-if="curYearReportData.f_pay == 0" class="year-result-content-fuzzy-1" :class="payFailedStatus['five'] ? 'fuzzy-long' : ''">
                            <p class="year-content-content-c-p">顺的年份通常会事半功倍，逆的年份则会事倍功半，平的年份虽无外因特别助力，但贵在平平稳稳。提前知道在工作、人际关系、财运方面的注意事项提前做好规划就一定能够趋吉避凶，吉上加吉，逢凶化吉。</p>
                            <div class="report-result-button report-result-button-posab">
                                <year-report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:buttonText="'解锁完整报告'"
                                    v-bind:buttonKeys="'five'"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                                    v-bind:reportData="reportYearProduct"
                                    v-bind:clickFunc="clickPay">
                                </year-report-button>
                                <p class="year-report-result-button-note note-green">此部分报告约500字</p>
                            </div>
                        </div>
                        <!-- <report-re-pay-bar class="mag-t-1" v-if="curYearReportAIData.five && curYearReportAIData.five.x && curYearReportAIData.five.y"
                            :lastTime="curYearReportAIData.five.lastTime" :productData="reportYearProduct">
                        </report-re-pay-bar> -->
                        <!-- 数据表 -->
                        <div class="year-content-content-c-c" v-else>
                            <p class="year-content-content-c-p">顺的年份通常会事半功倍，逆的年份则会事倍功半，平的年份虽无外因特别助力，但贵在平平稳稳。提前知道在工作、人际关系、财运方面的注意事项提前做好规划就一定能够趋吉避凶，吉上加吉，逢凶化吉。</p>
                            <report-data-area-new v-if="curYearReportAIData.five && curYearReportAIData.five.x && curYearReportAIData.five.y" 
                                v-bind:canvasId="'dataYearFive'"
                                v-bind:curTimeIndex="curYearReportAIData.five.curIndex"
                                v-bind:xDataArr="curYearReportAIData.five.x_new"
                                v-bind:yDataArr="curYearReportAIData.five.y"
                                v-bind:levArr="curYearReportAIData.five.lev_new"
                                v-bind:clickFunc="clickReportFiveDataFunc">
                            </report-data-area-new>
                            <div v-if="curYearReportFiveData" class="report-result-ct-content report-result-detail">
                                <p class="year-result-detail-p">
                                    <span class="green-title">{{ curYearReportFiveData.title }}</span>
                                    <span v-if="curYearReportFiveData.lev" class="span-status" :class="curYearReportFiveData.lev.color">{{ curYearReportFiveData.lev.text }}</span>
                                </p>
                                <div v-if="curYearReportFiveData.msg">
                                    <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg"><span class="report-p-blue">总论：</span>{{ curYearReportFiveData.msg.base }}</p>
                                    <!-- <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg"><span class="report-p-blue">学业方面：</span>{{ curYearReportFiveData.msg.work }}</p> -->
                                    <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg && curYearReportFiveData.msg.work"><span class="report-p-blue">工作方面：</span>{{ curYearReportFiveData.msg.work }}</p>
                                    <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg"><span class="report-p-blue">人际关系：</span>{{ curYearReportFiveData.msg.people }}</p>
                                    <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg"><span class="report-p-blue">财运方面：</span>{{ curYearReportFiveData.msg.luck }}</p>
                                    <p class="year-result-detail-msg" v-if="curYearReportFiveData.msg"><span class="report-p-blue">建议方面：</span>{{ curYearReportFiveData.msg.suggest }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 2、天赋能力变化 -->
        <div id="talentBox" class="year-content-box year-content-box2">
            <div class="year-content-light2"></div>
            <div class="year-content-light3"></div>
            <div class="year-content-box-border">
                <div class="year-content-content">
                    <div class="year-content-title year-content-title2"><span>天赋能力变化</span></div>
                    <div class="year-content-content-c no-bg">
                        <div v-if="curYearReportData.f_pay == 0" class="year-result-content-fuzzy-2" :class="payFailedStatus['talent'] ? 'fuzzy-long' : ''">
                            <p class="year-content-content-c-p">每个人的先天天赋是出生带来的，但是她对应的能力会随着时空的变化而变化。而我们的能力和行动会决定我们的结果，合理利用自身能力的变化经常可能在一年的顺逆运势之外带来意想不到的好结果。</p>
                            <div class="report-result-button report-result-button-posab">
                                <year-report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:buttonText="'解锁完整报告'"
                                    v-bind:buttonKeys="'talent'"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                                    v-bind:reportData="reportYearProduct"
                                    v-bind:clickFunc="clickPay">
                                </year-report-button>
                                <p class="year-report-result-button-note note-green">此部分报告约500字</p>
                            </div>
                        </div>
                        <div class="year-content-content-c-c" v-else>
                            <p class="year-content-content-c-p">每个人的先天天赋是出生带来的，但是她对应的能力会随着时空的变化而变化。而我们的能力和行动会决定我们的结果，合理利用自身能力的变化经常可能在一年的顺逆运势之外带来意想不到的好结果。</p>
                            <nature-talent :resultType="'year'" class="report-nature-content-box year-report-nature-content-box"></nature-talent>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 3、详细月运 -->
        <div id="monthBox" class="year-content-box year-content-box2">
            <div class="year-content-light2"></div>
            <div class="year-content-light3"></div>
            <div class="year-content-box-border">
                <div class="year-content-content">
                    <div class="year-content-title year-content-title3"><span>{{curYear}}年详细月运</span></div>
                    <div class="year-content-content-c no-bg">
                        <div v-if="curYearReportData.f_pay == 0" class="year-result-content-fuzzy-3" :class="payFailedStatus['month'] ? 'fuzzy-long' : ''">
                            <p class="year-content-content-c-p">好的年份会有差的月份，需要小心；但差的年份也总有好的月份，有时候一年的收成就靠那几个月化腐朽为神奇。</p>
                            <div class="report-result-button report-result-button-posab">
                                <year-report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:buttonText="'解锁完整报告'"
                                    v-bind:buttonKeys="'month'"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                                    v-bind:reportData="reportYearProduct"
                                    v-bind:clickFunc="clickPay">
                                </year-report-button>
                                <p class="year-report-result-button-note note-green">此部分报告约3000字+，建议先通读，再每月月前回顾</p>
                            </div>
                        </div>
                        <div class="year-content-content-c-c" v-else>
                            <p class="year-content-content-c-p">好的年份会有差的月份，需要小心；但差的年份也总有好的月份，有时候一年的收成就靠那几个月化腐朽为神奇。</p>
                            <!-- <report-re-pay-bar class="mag-t-1" v-if="resultType != 'strong' && curYearReportAIData.five && curYearReportAIData.five.x && curYearReportAIData.five.y"
                                :lastTime="curYearReportAIData.five.lastTime" :productData="reportYearProduct">
                            </report-re-pay-bar> -->
                            <!-- 数据表 -->
                            <report-data-area-new v-if="curYearReportAIData.month && curYearReportAIData.month.x && curYearReportAIData.month.y" 
                                v-bind:canvasId="'dataYearMonth'"
                                v-bind:curTimeIndex="curYearReportAIData.month.curIndex"
                                v-bind:xDataArr="curYearReportAIData.month.x_new"
                                v-bind:yDataArr="curYearReportAIData.month.y"
                                v-bind:levArr="curYearReportAIData.month.lev_new"
                                v-bind:clickFunc="clickReportMonthDataFunc">
                            </report-data-area-new>
                            <div class="report-result-detail-info">
                                <p>点击月份可按月查看解析<span class="info-span" @click="updateMonthContent">{{ curYearReportMonthShowAll ? '收起所有内容' : '展开所有内容' }}</span></p>
                            </div>
                            <div class="report-result-detail-month report-result-detail-month2" v-for="monthData in curYearReportMonthDataList">
                                <p class="year-result-detail-p year-result-detail-p2">
                                    <span class="report-green-title">{{ monthData.title }}</span>
                                    <span v-if="monthData.lev" class="span-status" :class="monthData.lev.color">{{ monthData.lev.text }}</span>
                                </p>
                                <p class="year-result-detail-msg"><span class="report-p-blue">总论：</span>{{ monthData.msg.base }}</p>
                                <p class="year-result-detail-msg"><span class="report-p-blue">工作方面：</span>{{ monthData.msg.work }}</p>
                                <p class="year-result-detail-msg"><span class="report-p-blue">人际关系：</span>{{ monthData.msg.people }}</p>
                                <p class="year-result-detail-msg"><span class="report-p-blue">财运方面：</span>{{ monthData.msg.luck }}</p>
                                <p class="year-result-detail-msg"><span class="report-p-blue">建议方面：</span>{{ monthData.msg.suggest }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 4、人生大运轨迹 -->
        <div id="dayunBox" class="year-content-box year-content-box2">
            <div class="year-content-light2"></div>
            <div class="year-content-light3"></div>
            <div class="year-content-box-border">
                <div class="year-content-content">
                    <div class="year-content-title year-content-title2"><span>人生大运轨迹</span></div>
                    <div class="year-content-content-c no-bg">
                        <div v-if="curYearReportData.f_pay == 0" class="year-result-content-fuzzy-4" :class="payFailedStatus['dayun'] ? 'fuzzy-long' : ''">
                            <p class="year-content-content-c-p">获悉人生总体大运轨迹，知道现在好与不好的大环境状况，能帮助调整心态，更好经营人生，做到心中有数，处变不惊。</p>
                            <p class="year-content-content-c-p green">指引：好的年份又在好的大运，那是人生得意时；好的年份在不好的大运，那也可能在这个大运里因这一年而意想不到；差的年份在好的大运里，虽然稍显不顺，但是总体还是向好；差的年份又在差的大运里，那自然是要注意多炼内功，待时而动。如遇平运，平平淡淡才是真，福虽未致，祸已远去。</p>
                            <div class="report-result-button report-result-button-posab">
                                <year-report-button
                                    v-bind:buttonType="'2'"
                                    v-bind:buttonText="'解锁完整报告'"
                                    v-bind:buttonKeys="'dayun'"
                                    v-bind:vipBtn="userData && parseInt(userData.vip) >= 30"
                                    v-bind:reportData="reportYearProduct"
                                    v-bind:clickFunc="clickPay">
                                </year-report-button>
                                <p class="year-report-result-button-note note-green">此部分报告约500字</p>
                            </div>
                        </div>
                        <div class="year-content-content-c-c" v-else>
                            <p class="year-content-content-c-p">获悉人生总体大运轨迹，知道现在好与不好的大环境状况，能帮助调整心态，更好经营人生，做到心中有数，处变不惊。</p>
                            <p class="year-content-content-c-p green">指引：好的年份又在好的大运，那是人生得意时；好的年份在不好的大运，那也可能在这个大运里因这一年而意想不到；差的年份在好的大运里，虽然稍显不顺，但是总体还是向好；差的年份又在差的大运里，那自然是要注意多炼内功，待时而动。如遇平运，平平淡淡才是真，福虽未致，祸已远去。</p>
                            <!-- 数据表 -->
                            <report-data-area-new v-if="curYearReportAIData.daYun && curYearReportAIData.daYun.x && curYearReportAIData.daYun.y" 
                                v-bind:canvasId="'dataYearDayun'"
                                v-bind:curTimeIndex="curYearReportAIData.daYun.curIndex"
                                v-bind:xDataArr="curYearReportAIData.daYun.x_new"
                                v-bind:yDataArr="curYearReportAIData.daYun.y"
                                v-bind:levArr="curYearReportAIData.daYun.lev_new">
                            </report-data-area-new>
                            <div class="report-result-detail-month report-result-detail-month2" v-for="dayunData in curYearReportDayunDataList">
                                <p class="year-result-detail-p year-result-detail-p2">
                                    <span class="report-green-title">{{ dayunData.title }}</span>
                                    <span class="span-status" :class="dayunData.lev_new.color">{{ dayunData.lev_new.text }}</span>
                                </p>
                                <p class="year-result-detail-msg">{{ dayunData.msg }}</p>
                            </div>
                            <div class="year-report-detail-subinfo">
                                <p class="report-p-blue">备注：大运就算是逆境，也会因为配合大运下面的年份(即流年)较好而发生质变，如果你目前所在的大运是逆境，那么要想更好的施展，除了寄希望于更好的年份出现，更加需要懂得趋吉避凶的方法。</p>
                                <p class="report-p-blue">系统会默认展示80年大运趋势，并不代表寿命只能活到80岁，能活过百岁的人将越来越多，跟时代发展及个人身心健康习惯、饮食作息习惯有直接关系。相同八字的人有长命百岁的，也有年轻夭折的，区别就在于后天的趋吉避凶是否踩准点了。所以说，易学八字是个很好的趋吉避凶的工具，但千万不可迷信宿命，毕竟事在人为。</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 5、底部信息部分 -->
        <div class="year-result-content-button">
            <div class="report-result-content-title report-result-content-title-3">
                <p>八字属于概率学，虽不可能百分之百准确，但因积累数千年，其中的智慧依然会给每个人带来巨大参考价值。<span class="red2">智能测算属于知识付费，一旦付费不予退款，谢谢理解。</span></p>
            </div>

            <div class="report-result-button-unlock" v-if="userData && parseInt(userData.vip) < 30"> <!--v-if="curYearReportData.f_pay == 0"-->
                <button class="report-rbul-button report-rbul-button-3" @click="clickVipButton">
                    <p class="report-rbul-button-p">终身会员免费解锁</p>
                    <p class="report-rbul-button-p">零基础八字及六爻入门课程</p>
                </button>
            </div>
            <div class="report-result-button-sub-text">
                <p>非专业人士谨记：科学用易学，切勿迷信之！</p>
                <p>专业人士谨记：科学传易学，顺时代之道，积口德，</p>
                <p>行善事，德蓄万物！</p>
            </div>
        </div>

        <!-- 6、提示解锁成功的弹框 -->
        <van-popup class="report-result-suc" v-bind:value="showPaySuc" @click-overlay="clickPayPop">
            <div class="report-result-suc-content">
                <img v-bind:src="sucGif" alt="">
            </div>
        </van-popup>
    </div>
</template>

<script>
import { MIX, UTILS } from '../../modules/utils';
import YearReportButton from './YearReportButton.vue'
import ReportDataAreaNew from '../report/ReportDataAreaNew.vue'
import NatureTalent from '../nature/NatureTalent.vue'
import ReportRePayBar from '../report/ReportRePayBar.vue';
import ReportInfo from '../report/ReportInfo.vue';
import { CONFIG } from '../../modules/config'
import { YEAR_DOM } from '../../modules/dom';
export default {
    name: 'YearReportResult',
    props: {
        resultType: {
            type: String,
            default() { return '' }
        },
    },
    components: { YearReportButton, ReportDataAreaNew, NatureTalent, ReportRePayBar, ReportInfo },
    computed: {
        userData() {
            return this.$store.state.userData ? this.$store.state.userData.info : {};
        },
        curYear() {
            return this.$store.state.year.curYear;
        },
        curYearReportData() {
            return this.$store.state.year.curYearReportData;
        },
        curYearReportAIData() {
            return this.$store.state.year.curYearReportAIData;
        },
        curYearReportFiveData() {
            return this.$store.state.year.curYearReportFiveData;
        },
        curYearReportMonthShowAll() {
            return this.$store.state.year.curYearReportMonthShowAll;
        },
        curYearReportMonthDataList() {
            return this.$store.state.year.curYearReportMonthDataList;
        },
        curYearReportDayunDataList() {
            return this.$store.state.year.curYearReportDayunDataList;
        },
        reportYearProduct() {
            return this.$store.state.year.reportYearProduct;
        },
    },
    data() {
        return {
            UTILS: UTILS,
            monthXTitle: '(月)',
            fiveXTitle: '(年)',
            allXTitle: '(年)',
            monthXData: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
            monthYData: [130, 100, 150, 130, 150, 130, 100, 150, 130, 150, 100, 120],
            fiveXData: [2020, 2021, 2022, 2023, 2024],
            fiveYData: [130, 100, 150, 130, 150],
            allXData: [2020, 2030, 2040, 2050, 2060],
            allYData: [130, 100, 150, 130, 150],
            showPaySuc: false,
            sucGif: require('../../assets/images/report/report-suc.gif'),
            payFailedStatus: {},
        }
    },
    mounted() {
        this.$bus.on('showYearReportSuc', this.showYearReportSuc);
    },
    destroyed() {
        this.$bus.off('showYearReportSuc', this.showYearReportSuc);
    },
    methods: {
        clickPay(params) {
            var curYearReportData = this.$store.state.year.curYearReportData;
            console.log('clickPay--------', params, params.data, curYearReportData.id)
            // 会员特权免费解锁
            if(this.userData && this.userData.vip >= 30) {
                this.$store.dispatch('year/freeUnlockYearReport', {
                    id: curYearReportData.id,
                    sucCb: ()=> {
                        this.showYearReportSuc();
                        this.$store.dispatch('year/resetYearData');
                        this.$store.dispatch('year/getYearReportInfo');
                    },
                    failCb: ()=> {
                        this.$toast('免费解锁失败，请稍后再试');
                    }
                })
                return;
            }

            var payType = CONFIG.platform == 'qq' ? 'wx_qr' : params.data.payType[2];
            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: params.data.pid,              //支付项目id
                    ptype: payType,                    //支付方式
                    ext: curYearReportData.id          //支付的评测id
                },
                // mixParams: {
                //     pid: params.data.pid,
                //     product_name: params.data.title,
                //     price: params.data.price,
                //     from: 'generate_ai',
                // },
                sucCb: () => {
                    console.log('支付成功，更新年运报告数据');
                    this.showYearReportSuc();
                    // 更新数据
                    this.$store.dispatch('year/resetYearData');
                    this.$store.dispatch('year/getYearReportInfo');

                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                },
                failCb: ()=> {
                    // 支付失败显示长蒙版
                    setTimeout(() => {
                        this.clickPayFailed(params.keys);
                    }, 20);
                    
                    if(params.cb && typeof(params.cb) == 'function') {
                        params.cb();
                    }
                }
            });
        },
        clickPayFailed(keys) {
            console.log('params.data------', keys);
            this.$set(this.payFailedStatus, keys, true);
        },
        clickPayPop() {
            this.showPaySuc = false;
        },
        showYearReportSuc() {
            // 显示并定时隐藏支付成功提示
            this.showPaySuc = true;
            setTimeout(() => {
                this.showPaySuc = false;
                YEAR_DOM.initYearPageHeightList();
                setTimeout(() => {
                    YEAR_DOM.bindYearScrollEvent();
                }, 20);
            }, 3000);
        },
        clickVipButton() {
            var curYearReportData = this.$store.state.year.curYearReportData;
            if((this.userData && parseInt(this.userData.vip) < 30) || (curYearReportData.f_pay != 0)) {
                this.$store.dispatch('user/showMyVipPop', {vip: 30, frompage: 'year_vipbutton'});
                setTimeout(() => {
                    this.$bus.emit('initMyVipPage');
                }, 20);
                return;
            }else {
                console.log('免费解锁', curYearReportData)
                this.$store.dispatch('year/freeUnlockYearReport', {
                    id: curYearReportData.id,
                    sucCb: ()=> {
                        this.showYearReportSuc();
                        this.$store.dispatch('year/resetYearData');
                        this.$store.dispatch('year/getYearReportInfo');
                    },
                    failCb: ()=> {
                        this.$toast('免费解锁失败，请稍后再试');
                    }
                })
            }
        },
        clickReportFiveDataFunc(params) {
            let year = params.name.split(',')[0]; year = parseInt(year);
            this.$store.dispatch('year/updateCurYearReportData', {
                year: year
            });
        },
        updateMonthContent() {
            this.$store.dispatch('year/updateCurYearReportMonthDataStatus');
        },
        clickReportMonthDataFunc(params) {
            this.$store.dispatch('year/updateCurYearReportMonthDataList', {index: params.index})
        }
    }
}
</script>